import React, { FC, ReactElement } from 'react';
import { ConfigYamlTeges } from '../../gatsby-types';
import { ImageAtom } from './ImageAtom';
import { MaterialIcon } from './MaterialIcon';
import { TegeDescription } from './TegeDescription';
import { TegeName } from './TegeName';

type Props = Readonly<{
  teges: Array<ConfigYamlTeges>;
}>;

export const TegeContainer: FC<Props> = ({ teges }): ReactElement => {
  return (
    <div className='container grid sm:grid-cols-none md:grid-cols-3 gap-1 max-w-full mx-auto p-2 flex flex-wrap'>
      {teges.map<ReactElement>((tege: ConfigYamlTeges, i: number) => (
        <div key={i} className='rounded overflow-hidden shadow-lg'>
          <ImageAtom filename={tege.tegeimage}/>
          <div className='px-6 py-4'>
            <TegeName name={tege.tegename}/>
            <TegeDescription description={tege.tegedescription}/>
          </div>
          <div className='px-6 py-4'>
            <MaterialIcon name='schedule' text={`${tege.tegetime ?? '?'} mins`} className='bg-gray-200 rounded-full'/>
            <MaterialIcon name='person' text={tege.tegepersons} className='bg-gray-200 rounded-full'/>
            <MaterialIcon name='local_offer' text={tege.tegegenre} className='bg-gray-200 rounded-full'/>
            <MaterialIcon name='emoji_objects' text={tege.tegeimpression} className='bg-gray-200'/>
          </div>
        </div>
      ))}
    </div>
  );
};
